<template>
  <div style="background: white;padding:20px;padding-right:10px;margin-bottom:20px;">
    <div style="display: flex;justify-content: space-between">
      <div>售前介入任务列表</div>
      <el-button size="mini" type="primary" @click="addContent">添加</el-button>
    </div>
    <div v-if="cluePreSales && cluePreSales.length" style="margin-top:20px;max-height: 80vh;overflow: scroll;" v-loading="loading">
      <el-table :data="cluePreSales" stripe>
        <el-table-column v-for="col in columns"
          :prop="col.id"
          :key="col.id"
          :label="col.label">
        </el-table-column>
      </el-table>
    </div>

    <el-empty v-else description="暂无数据"></el-empty>

    <addPreSale v-model="showDialog" @submit="createPreSale" />
  </div>
</template>

<script>

import {
  getPreSaleTaskList,
  createPreSaleTask
} from '../../../api/api'
import addPreSale from "@/component/Business/dialog/addPreSale";
import VueCookies from 'vue-cookies'

export default {
  name: "BusinessPreSales",
  props:["clue_id"],
  components:{
    addPreSale
  },
  data(){
    return {
      loading:false,
      cluePreSales: [],
      showDialog:false,

      columns: [
        { id: 'task_type', label: '任务类型', width: 120 },
        { id: 'estimate', label: '预计投入工时', width: 120 },
        { id: 'consumed', label: '已投入工时', width: 120 },
        { id: 'left', label: '预计剩余工时', width: 120 },
        { id: 'comment', label: '最新备注', width: 120 },
      ]
    }
  },
  async mounted() {
    this.refresh(false)
  },

  watch:{
    clue_id(){
      this.refresh()
    },
    showDialog(newVal){
      if(!newVal){
        this.refresh()
        this.$emit('refreshData',true)
      }
    }
  },

  methods:{
    async getData(){
      let postData = {
        clue_id: this.clue_id
      }
      let res = await getPreSaleTaskList(postData)
      let newVal = res.data.respData
      this.cluePreSales = null
      this.$nextTick(()=>{
        this.cluePreSales = newVal.presale_task
        this.loading = false
      })
    },

    async refresh(loading=true){
      this.loading = loading
      await this.getData()
    },
    addContent(){
      this.showDialog = true
    },
    createPreSale(data) {
      createPreSaleTask({
        clue_id: this.clue_id,
        pre_sale_principal: data.pre_sale_principal,
        estimate_start_date: data.estimate_start_date,
        task_type: data.task_type,
        estimate_hour: data.man_day * 8,
        account_manager: VueCookies.get('username'),
        priority: data.priority,
      }).then(result => {
        const res = result.data
        if (res.respCode === '000000') {
          this.$message.success('添加成功')
        } else {
          this.$message.error('添加失败')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.plain-body{
  padding:10px;
  .plain-header{
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
    .plain-img{
      width:20px;
      height:20px;
      border-radius: 50%;
      background-color: gray;
      margin-right:6px;
    }
    .plain-user-name{
      color: gray;
    }
  }
  .plain-content{
    color: black;
    font-size: 14px;
    margin-bottom: 10px;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }
  .plain-time{
    font-size: 10px;
    color: lightgrey;
  }
}

</style>

